import axiosInstance from '..';

export const userUploadAvatar = async (formData: FormData) =>
  await axiosInstance.post(`/v2/Profile/UploadAvatar`, formData);

export const userTask = async (id: number) => await axiosInstance.get(`/v1/UserTask?Id=${id}`);
